import React, { useState, useContext, useEffect } from 'react';
import { AvailabilityPageContainer, PageHeadlineComponent, PageMainContentContainer } from '../MentorAvailabilityPage/MentorAvailabilityPageStyles';
import { CalendarIconContainer, CalendarOptionButton, CalendarOptionContainer, CalendarPictureAndNameContainer } from './MentorCalendarIntegrationStyles';
import { GoogleCalendarIntegrationComponent } from './GoogleCalendarIntegration';
import { getMPDataWithoutParams, getCountryCode } from 'src/mentor/services';
import { useLocation } from 'react-router-dom';

export default function MentorCalendarIntegrationsPage() {

    const [tempCalendarConnected, setTempCalendarConnected] = useState(false)

    const location = useLocation();

    async function sendCodeToServer() {
        const queryParams = new URLSearchParams(location.search);
        const code = queryParams.get("code");
        if (code) {
            const response = await getMPDataWithoutParams(`/api/secure/teacher/connect-calendar?type=google&token=${code}&platform=web&countryCode=${getCountryCode()}&languageCode=${sessionStorage.getItem('languageCode')}`);
            if (response?.status === 200) {
                setTempCalendarConnected(true)
            } else {
                alert("Error connecting calendar")
            }
        }
    }

    useEffect(() => {
        sendCodeToServer();
    }, [])

    return (
        <AvailabilityPageContainer>

            <PageHeadlineComponent heading="Integrate your Calendars" />

            <PageMainContentContainer>

                <GoogleCalendarIntegrationComponent tempCalendarConnected={tempCalendarConnected} />

            </PageMainContentContainer>

        </AvailabilityPageContainer>
    )
}